import Vue from 'vue'
import VueRouter from 'vue-router'
import checkArticle from '../components/checkArticle'
import articleInfo from '../pages/articleInfo'

Vue.use(VueRouter)
export default new VueRouter({
  routes: [
    {
      path: '/checkArticle',
      name: 'checkArticle',
      component: checkArticle
    },
    {
      path: '/',
      redirect: '/checkArticle'//默认显示
    },
    {
      path: '/articleInfo',
      name: 'articleInfo',
      component: articleInfo,
      meta: {
        // 页面标题title
        title: '文章详情页-北鲲大数据'
      }
    }
  ]
})